(function () {
  function initKlaviyoReviewsTweaks() {
    const root =
      document.getElementById('klaviyo-reviews-all-reviews-wrapper') ||
      document.querySelector('.kl_reviews__all_container') ||
      document.querySelector('.kl_reviews');

    if (!root) return false;

    const listContainer = root.querySelector('.kl_reviews__list_container');
    if (!listContainer) return false;

    // Default to Product reviews tab
    const productTab =
      root.querySelector('#kl_reviews__tabs_product_reviews_tab') ||
      root.querySelector('[id*="product_reviews_tab"]');

    if (productTab && productTab.getAttribute('aria-selected') !== 'true') {
      productTab.click();
    }

    // Unlock list when "Show more" is clicked
    root.addEventListener('click', function (e) {
      const btn = e.target.closest('button');
      if (!btn) return;

      const txt = (btn.textContent || '').trim().toLowerCase();
      const isShowMore =
        txt === 'show more' ||
        btn.classList.contains('kl_reviews__load_more_button') ||
        btn.closest('.kl_reviews__load_more');

      if (isShowMore) {
        listContainer.setAttribute('data-wsh-expanded', 'true');
      }
    });

    return true;
  }

  let tries = 0;
  const timer = setInterval(function () {
    tries++;
    if (initKlaviyoReviewsTweaks() || tries > 40) clearInterval(timer);
  }, 250);
})();
